import type React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@heroui/react';
import { renderNotice } from '@/pages/catalogImport/notices';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import type { ImportSubmitState } from '../../importSubmit';

type SuggestedFixesSubmitFailureProps = {
    submit: ImportSubmitState;
};

/**
 * Why the confirmed import did not go through, under the summary: its
 * sentences as a list, or that there was no answer; nothing before a
 * confirm or after one that went through.
 */
export const SuggestedFixesSubmitFailure: React.FC<
    SuggestedFixesSubmitFailureProps
> = ({ submit }) => {
    const { t } = useTranslation('pages');
    if (submit.status === 'idle') {
        return null;
    }
    return (
        <Alert
            status="danger"
            {...getNodeTestIdProp(
                'catalog-import-suggested-fixes-import-failed',
            )}
        >
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>
                    {t('catalogImport.products.import.failedTitle')}
                </Alert.Title>
                {submit.status === 'failed' ? (
                    <Alert.Description>
                        {t('catalogImport.products.import.noAnswer')}
                    </Alert.Description>
                ) : (
                    <Alert.Description>
                        <ul className="flex flex-col gap-1">
                            {submit.notices.map((notice) => (
                                <li key={notice.key}>
                                    {renderNotice(t, notice)}
                                </li>
                            ))}
                        </ul>
                    </Alert.Description>
                )}
            </Alert.Content>
        </Alert>
    );
};
